import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './style.css'

import App from './App.vue'
import router from './router'

import './api/interceptors'
import './echo'

const app = createApp(App)

;(window as any).Beacon?.init({ dsn: 'https://5XXRzhhupPzZw785yTdUwZT7e1UQ2ltP6k5Q@relay.beaconhq.dev/019e3d24-5940-734a-bef4-7efc4b8512b2' })
;(window as any).Beacon?.install(app)

app.use(createPinia())
app.use(router)

app.mount('#app')
